export const handleWidgetVisibility = (visible) => {
  const widgetElement = document.querySelector('.cce-widget-container')
  const widgetWindowElement = document.querySelector('.cce-widget__window')
  if (!widgetElement) return

  widgetElement.classList.toggle('minimized', !visible)
  widgetWindowElement.classList.toggle('cce-widget__window--open', visible)
}
